import { useStravaActivities } from "strava-acquisition/hooks/use-strava-activities";
import styles from "./strava-connection-badge.module.css";

interface StravaConnectionBadgeProps {
  onChooseActivity: () => void;
  onDisconnect?: () => void;
}

export const StravaConnectionBadge = ({
  onChooseActivity,
  onDisconnect,
}: StravaConnectionBadgeProps) => {
  const { clearActivitiesData } = useStravaActivities();

  const handleDisconnect = () => {
    clearActivitiesData();
    onDisconnect?.();
  };

  return (
    <div className={styles.container}>
      <div className={styles.connectionBanner}>
        <div className={styles.bannerContent}>
          <svg className={styles.bannerIcon} viewBox="0 0 16 16" fill="currentColor">
            <path d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.267.267 0 0 1 .02-.022z"/>
          </svg>
          <span className={styles.bannerText}>Connected to Strava</span>
        </div>
        <button className={styles.disconnectButton} onClick={handleDisconnect}>
          Disconnect
        </button>
      </div>

      <button className={styles.chooseActivityButton} onClick={onChooseActivity}>
        <svg className={styles.stravaIcon} viewBox="0 0 24 24" fill="currentColor">
          <path d="M15.387 17.944l-2.089-4.116h-3.065L15.387 24l5.15-10.172h-3.066m-7.008-5.599l2.836 5.598h4.172L10.463 0l-7 13.828h4.169" />
        </svg>
        Choose a Strava activity
      </button>
    </div>
  );
};
